// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperModal-cls1__efc56fbe2efcaa871571","cls2":"MultiPaperModal-cls2__d3adf0155951356106c9 MultiPaperModal-cls1__efc56fbe2efcaa871571"};